





































































import { Product } from '@/models'
import ApiClient from '@/services/api-client'
import ApiGtag, { Category } from '@/services/api-gtag'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class SearchProducts extends Vue {
  private loading = false
  private products: Array<Product> = []
  private typingInterval = 300
  private typingTimer: NodeJS.Timeout = setTimeout(() => { return false }, 500000)
  private textSearched = ''

  private fields = [
    { key: 'id', label: this.translateCol('id') },
    { key: 'editorialProjectLabel', label: this.translateCol('editorialProjectLabel') },
    { key: 'title', label: this.translateCol('title') }
  ]

  private translateCol(colName: string) {
    return this.$i18n.t('searchProducts_component.table.fields.' + colName)
  }

  public goPath(item: Product): void {
    const path = `/projects/${item.editorialProject}/course/${item.id}`
    this.$router.push(path)
  }

  public enterClicked(): void {
    clearTimeout(this.typingTimer)
    this.typingTimer = setTimeout(this.searchProducts, this.typingInterval)
  }

  public searchProducts(): void {
    this.loading = true
    const searchText: string = this.textSearched
    ApiClient.getProducts(searchText)
      .then(products => {
        this.products = products
        this.loading = false
        ApiGtag.sendEvent(Category.Search, 'Search Course', this.textSearched)
      })
      .catch(err => {
        console.error('Error searchProducts: ' + err)
        this.loading = false
      })
  }

  created() {
    this.searchProducts()
  }
}
